import { render, staticRenderFns } from "./PaymentTransactionDestination.vue?vue&type=template&id=d0fc7022"
import script from "./PaymentTransactionDestination.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionDestination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports